import { useEffect, useRef } from "react";

import { ExperienceCategory } from "@intelligems/ig-types";
import { useQueryClient } from "@tanstack/react-query";

import { useGetExperiencesList } from "../experiences-list/get-experiences-list";
import { experienceKeys, historyKeys } from "../queryKeys";

import { getExperience } from "./get-experience";

export const usePrefetchPendingExperiences = async (
  category: ExperienceCategory
) => {
  const experiencesList = useGetExperiencesList({ category });
  const queryClient = useQueryClient();
  const fetchingRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      if (experiencesList.isSuccess) {
        experiencesList.data.experiencesList.map((exp) =>
          queryClient.setQueryData(historyKeys.one(exp.id), {
            history: exp.history,
          })
        );
        await Promise.all(
          experiencesList.data.experiencesList?.map(async (exp) => {
            if (exp.status === "pending") {
              await queryClient.prefetchQuery({
                queryKey: experienceKeys.one(exp.id),
                queryFn: async () => getExperience(exp.id),
              });
            }
          })
        );
      }
    };

    void fetchData();
  }, [experiencesList.isSuccess, experiencesList.data]);

  useEffect(() => {
    if (
      experiencesList.hasNextPage &&
      !experiencesList.isFetchingNextPage &&
      !fetchingRef.current
    ) {
      fetchingRef.current = true;
      void experiencesList.fetchNextPage().finally(() => {
        fetchingRef.current = false;
      });
    }
  }, [experiencesList.hasNextPage, experiencesList.isFetchingNextPage]);
};
